import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const CheckRules = ({ data }) => {
  const { t } = useTranslation(['common'])

  const executedRules = useMemo(() => {
    return data?.metadata?.rules?.executedRules || []
  }, [data])

  if (!executedRules.length) return null

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('common:title')}</TableCell>
            <TableCell>{t('common:ruleId')}</TableCell>
            <TableCell>{t('common:hit')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {executedRules.map((rule, index) => (
            <TableRow key={index}>
              <TableCell>{rule.executedRule.ruleName || rule.executedRule.title || '---'}</TableCell>
              <TableCell>{rule.executedRule.ruleId || '---'}</TableCell>
              <TableCell>
                {rule.executedRule.ruleHit !== undefined
                  ? rule.executedRule.ruleHit
                    ? t('common:yes')
                    : t('common:no')
                  : rule.executedRule.result ?? '---'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CheckRules
